import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext.jsx';
import { AlertIcon } from '../common/icons.jsx';
import { MailIcon, LockIcon, BikeIcon } from '../common/iconsExtra.jsx';

export default function LoginPage() {
  const [email, setEmail] = useState(localStorage.getItem('lastEmail') || '');
  const [password, setPassword] = useState('');
  const [pin, setPin] = useState('');
  const [mode, setMode] = useState(localStorage.getItem('lastEmail') ? 'pin' : 'password');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, pinLogin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      localStorage.setItem('lastEmail', email);
      if (mode === 'pin') {
        await pinLogin(email, pin);
      } else {
        await login(email, password);
      }
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0f172a] via-[#1e3a5f] to-[#0891b2] px-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-sm animate-fade-in">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#0f172a] to-[#0891b2] flex items-center justify-center mb-3">
            <BikeIcon size={28} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-[var(--color-primary)]">Velogistique</h1>
          <p className="text-sm text-[var(--color-neutral)] mt-1">Logistique terrain</p>
        </div>

        {/* Mode toggle */}
        <div className="flex gap-1 mb-6 bg-gray-100 rounded-xl p-1">
          <button
            type="button"
            onClick={() => setMode('password')}
            className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition-all ${
              mode === 'password'
                ? 'bg-white text-[var(--color-primary)] shadow-sm'
                : 'text-[var(--color-neutral)] hover:text-gray-700'
            }`}
          >
            Mot de passe
          </button>
          <button
            type="button"
            onClick={() => setMode('pin')}
            className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition-all ${
              mode === 'pin'
                ? 'bg-white text-[var(--color-primary)] shadow-sm'
                : 'text-[var(--color-neutral)] hover:text-gray-700'
            }`}
          >
            PIN rapide
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Email field */}
          <div className="relative">
            <MailIcon size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className="w-full pl-11 pr-4 py-3 border border-gray-200 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-[var(--color-accent)] focus:border-[var(--color-accent)] focus:outline-none"
            />
          </div>

          {/* Password or PIN */}
          {mode === 'password' ? (
            <div className="relative">
              <LockIcon size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="password"
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className="w-full pl-11 pr-4 py-3 border border-gray-200 rounded-xl text-sm bg-gray-50 focus:bg-white focus:ring-2 focus:ring-[var(--color-accent)] focus:border-[var(--color-accent)] focus:outline-none"
              />
            </div>
          ) : (
            <div className="relative">
              <LockIcon size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]{6}"
                maxLength={6}
                placeholder="PIN (6 chiffres)"
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 6))}
                required
                autoComplete="one-time-code"
                className={`w-full pl-11 pr-4 py-3 border border-gray-200 rounded-xl text-center text-xl bg-gray-50 focus:bg-white focus:ring-2 focus:ring-[var(--color-accent)] focus:border-[var(--color-accent)] focus:outline-none ${pin ? 'tracking-[0.3em]' : 'text-sm tracking-normal'}`}
              />
            </div>
          )}

          {/* Error */}
          {error && (
            <div className="flex items-center gap-2 text-[var(--color-error)] bg-red-50 rounded-xl px-4 py-2.5 text-sm">
              <AlertIcon size={16} className="shrink-0" />
              <span>{error}</span>
            </div>
          )}

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-[var(--color-accent)] to-[var(--color-teal)] text-white py-3.5 rounded-xl font-semibold text-sm hover:opacity-90 disabled:opacity-50 shadow-lg shadow-blue-500/20 min-h-[44px]"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Connexion...
              </span>
            ) : (
              'Se connecter'
            )}
          </button>
        </form>

        <p className="text-center text-xs text-gray-400 mt-4">
          Mot de passe oublié ? Contactez votre coordinateur.
        </p>
      </div>
    </div>
  );
}
